module.exports = __webpack_public_path__ + "static/media/sidebar_lobby_inactive.2cb4ee00.svg";